export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '40px',
  xxxl: '60px'
};

export const shadows = {
  sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
  md: '0 4px 6px rgba(0, 0, 0, 0.1)',
  focus: '0 0 0 3px rgba(10, 89, 83, 0.1)'
};

export const breakpoints = {
  tablet: '1024px'
};

export const transitions = {
  default: 'all 0.2s ease'
};

export const images = {
  sizes: {
    logo: '60px',
    icon: '24px',
    avatar: '48px'
  }
}; 